import React, { useState, useEffect } from 'react';

export const withWujiPayList = (Component) => (props) => {
  const PayListComponent = (props) => {
    const [payList, setPayList] = useState([]);
    useEffect(() => {
    const wuji = `https://node.video.qq.com/x/api/wuji_public/switch/object?appid=leadswebtest&schemaid=refund&schemakey=26ec26e9ef2d498193978734810c786a&accountId=${window.pageProps.uid}`;
    fetch(wuji)
      .then((response) => response.json())
      .then((res) => {
        setPayList(res.data.reverse());
      })
      .catch((e) => console.log('Oops, error', e));
    }, []);
      return <Component {...props} monthList={payList} />;
  };
  PayListComponent.displayName = 'MyComponent';
  return <PayListComponent {...props} />;
};
